import React from 'react';
import './About.css';

const About = () => {
    return (
        <section className="about-section" id="about">
            <div className="about-container">

                <div className="about-header">
                    <div className="about-header-text">
                        <span className="section-subtitle">ABOUT PRIME REHAB INDUSTRIES</span>
                        <h2 className="section-title">
                            Engineering Advanced<br />
                            Physiotherapy & Rehabilitation<br />
                            Equipment
                        </h2>
                    </div>
                    <div className="about-header-btn">
                        <button className="btn-primary">KNOW MORE ABOUT US</button>
                    </div>
                </div>

                <div className="about-columns">
                    <div className="about-left">
                        <p className="about-desc">
                            Prime Rehab Industries is a leading manufacturer of clinically engineered physiotherapy and rehabilitation equipment. Our products are designed to support physiotherapy, chiropractic, orthopaedic, and neurological treatments in modern healthcare environments.
                        </p>

                        <div className="about-stats">
                            <div className="stat-item">
                                <span className="stat-number">100+</span>
                                <span className="stat-text">Physiotherapy &<br />Rehabilitation Products</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-number">12+</span>
                                <span className="stat-text">Total years<br />of experience</span>
                            </div>
                        </div>

                        <p className="about-subdesc">
                            With a focus on precision manufacturing, ergonomic design, and reliable clinical performance, our equipment helps therapists deliver safe and effective rehabilitation for patients. Prime Rehab Industries is trusted by clinics, hospitals, and rehabilitation centres for durable, high-quality therapy solutions.
                        </p>
                    </div>

                    <div className="about-right">
                        <img
                            src="https://primerehab.ascentbw.com/Image/Home/AbtImg.png"
                            alt="Physiotherapy Equipment"
                        />
                    </div>
                </div>

                <div className="about-bottom">
                    <div className="value-box">
                        <h4>our mission</h4>
                        <p>To design and manufacture reliable physiotherapy and rehabilitation equipment that supports effective treatment and improves patient recovery.</p>
                    </div>
                    <div className="value-box">
                        <h4>our vision</h4>
                        <p>To become a trusted provider of innovative rehabilitation equipment for clinics, hospitals, and healthcare professionals.</p>
                    </div>
                    <div className="value-box">
                        <h4>story & goals</h4>
                        <p>Focused on quality engineering and practical design, Prime Rehab Industries aims to deliver durable equipment that enhances modern rehabilitation care.</p>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default About;
